import { DocumentIcon } from 'assets/icons';
import Button from 'components/button';

/**
 * The small empty state of a list (mockup « 1.5 · Liste – Aucune facture sur
 * la période »): a pictogram in a grey circle, a title, a line of text and at
 * most one secondary button, near the top of the list rather than centred in
 * the page. Every empty state of the site takes this layout: `EmptyState`
 * renders its types through it.
 *
 * `icon` is any element, the document by default; `description` and `action`
 * ({ label, onClick }) are optional.
 */
const CompactEmptyState = ({
  icon = <DocumentIcon wh={20} color="#374151" />,
  title,
  description,
  action,
}) => (
  // Full width: in a flex row (the missions list) it would otherwise shrink to
  // its text and sit on the left.
  <div className="flex flex-col items-center w-full px-4 pt-20 pb-10 text-center">
    <div className="flex items-center justify-center w-11 h-11 rounded-full bg-gray-100">
      {icon}
    </div>
    <div className="mt-4 text-base font-medium text-gray-900">{title}</div>
    {description && (
      <div className="mt-1 max-w-[380px] text-sm text-gray-500">
        {description}
      </div>
    )}
    {action && (
      <div className="mt-4">
        <Button color="SECONDARY" size="SM" onClick={action.onClick}>
          {action.label}
        </Button>
      </div>
    )}
  </div>
);

export default CompactEmptyState;
